import * as React from 'react';

import { ButtonRadioGroupField } from '@cian/components';

import { InlineBlock } from '../../../markup';

export interface IButtonRadioGroupParamViewProps {
  value: boolean | undefined;
  trueValue: string;
  falseValue: string;
  onValueChange(value: boolean | undefined): void;
  titleComment?: string;
}

export class ButtonRadioGroupParamView extends React.PureComponent<IButtonRadioGroupParamViewProps> {
  public render() {
    const props = this.props;

    return (
      <InlineBlock>
        <ButtonRadioGroupField
          uncheckable
          value={String(props.value)}
          onValueChange={value => props.onValueChange(value !== undefined ? value === 'true' : undefined)}
          values={[
            { value: 'false', label: props.falseValue },
            { value: 'true', label: props.trueValue },
          ]}
        />
      </InlineBlock>
    );
  }
}
